<template>
  <div>
    <el-card style="height: 100%" shadow="always" v-loading="loading" :body-style="{ padding: '0px' }">
      <el-collapse accordion v-model="active">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="row p-3 mt-2">
              <div class="col-12">
                <h3 class="text-navy">Logs</h3>
              </div>
            </div>
          </template>
          <div class="row p-3">
            <div v-loading="loading" class="col-12">
              <el-table :data="logs.data">
                <el-table-column label="ID" prop="id" width="120px" />
                <el-table-column label="Agent" prop="causer.full_name" />
                <el-table-column label="Type" prop="subject_type_name" />
                <el-table-column label="Sale #" prop="subject_type_name">
                  <template slot-scope="scope">
                    {{ scope.row.subject_type_name == 'Sale' ? scope.row.subject.ref_id : '--' }}
                  </template>
                </el-table-column>
                <el-table-column label="Trade #" prop="subject_type_name">
                  <template slot-scope="scope">
                    {{ scope.row.subject_type_name == 'Purchase' ? scope.row.subject.ref_id : '--' }}
                  </template>
                </el-table-column>
                <el-table-column label="Event" prop="description" />
                <el-table-column label="Date" prop="created_at">
                  <template slot-scope="scope">
                    {{ moment.utc(scope.row.created_at, 'YYYY-MM-DD HH:mm:ss').local().format('DD/MM/Y HH:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column type="expand" v-if="false">
                  <template v-slot="scope">
                    <div>
                      <div v-if="scope.row.properties && !Array.isArray(scope.row.properties)">
                        <div class="row">
                          <div class="col-4 row" v-for="key in Object.keys(scope.row.properties.attributes)" :key="key">
                            <div class="col-6 d-flex align-items-center justify-content-space-between">
                              <p class="mb-0">
                                {{ key }}
                              </p>
                            </div>
                            <div class="col-6 d-flex align-items-center justify-content-space-between">
                              <p class="mb-0">
                                {{
                                  scope.row.properties && scope.row.properties.old
                                  ? scope.row.properties.old[key] || "N/A"
                                  : "N/A"
                                }}
                                <i class="fas fa-arrow-right mx-1 fa-1x"></i>
                                {{ scope.row.properties.attributes[key] }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <p class="mb-0">
                          <strong>
                            <small> N/A </small>
                          </strong>
                        </p>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="py-3 d-flex justify-content-center justify-content-xl-end">
                <el-pagination small layout="prev, pager, next, total" :current-page.sync="currentPage"
                  @current-change="handleCurrentChange" :background="true" :page-size="perPage"
                  :page-count="logs.last_page" :total="logs.total" />
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

    </el-card>
  </div>
</template>
<script>
import Business from "../../../modelsPortal/Business";
import Log from "../../../modelsPortal/Log";
export default {

  props: {
    initial_business: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      logs: [],
      perPage: 10,
      currentPage: 1,
      active: ['1'],
    };
  },
  mounted() {
    this.getData(this.currentPage);
  },
  methods: {
    getData(page) {
      this.loading = true;

      let logs = new Log().for(new Business(this.initial_business))
        .select({
          'activityLog': [
            'id',
            'subject_type',
            'subject_id',
            'description',
            'created_at',
          ],
          'causer': [
            'id',
            'first_name',
            'last_name',
          ],
          'subject': [
            'id',
            'ref',
          ]
        })
        /*.select({
          'activityLog': [
            'id',
            'subject_type',
            'subject_id',
            'description',
            'created_at']
        })*/
        .page(page)
        .params({ 'per_page': this.perPage })
        .append('subject_type_name')
        .include('causer')
        .orderBy("-id");

      logs
        .get()
        .then((res) => {
          this.loading = false;
          this.logs = res;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    handleCurrentChange(page = 1) {
      this.getData(page);
    },
  }
};
</script>